/**
 * "Missed huddle" in a conversation (Slack's missed-call line in a DM): a huddle I was rung into and never joined, with
 * who rang me and Call back (joins the conversation's huddle and rings them: HuddleViewModel.callBack). Data from core
 * `Huddles.missedHuddle`, on the huddle message, so it also shows after the app was closed during the ring.
 */
import type { Member } from "@bundle/contracts";
import { Button, Card, Icon, Stack, Text } from "../../primitives/index.ts";
import { useT } from "../../i18n/I18nProvider.tsx";

export type MissedHuddleLineProps = {
  /** Who rang me (the directory's name; absent = unknown, the line reads just "Missed huddle"). */
  caller?: Member;
  /** Call back; absent = not offered (huddles off for me, or no calls here). */
  onCallBack?: () => void;
  testID: string;
};

export function MissedHuddleLine({ caller, onCallBack, testID }: MissedHuddleLineProps) {
  const t = useT();
  return (
    <Card padding="3" direction="horizontal" align="center" gap="2.5" testID={testID}>
      <Icon name="huddle" size="icon.sm" color="status.danger" />
      <Stack grow gap="0.5">
        <Text variant="footnote" weight="semibold">
          {t("huddle.missed.title")}
        </Text>
        {caller === undefined ? null : (
          <Text variant="caption" color="text.secondary" lines={1} testID={`${testID}-caller`}>
            {t("huddle.missed.caller", { name: caller.displayName })}
          </Text>
        )}
      </Stack>
      {onCallBack === undefined ? null : <Button label={t("huddle.missed.callBack")} icon="huddle" size="sm" onPress={onCallBack} testID={`${testID}-call-back`} />}
    </Card>
  );
}
